import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, first, map, Observable, tap } from 'rxjs';

import { InitCategoryPage } from '../store/category-page.actions';
import { hasErrorOnLoadCategoryPage } from '../store/category-page.selectors';

import { handleNavigationCanActivateUseCase } from '@layout/ui/services/handle-navigation-can-activate.use-case';

export const canActivateCategoryPage: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
    router: Router = inject(Router),
): Observable<boolean> => {
    const store: Store = inject(Store);

    store.dispatch(InitCategoryPage());

    return store.select(hasErrorOnLoadCategoryPage).pipe(
        filter(hasError => hasError != null),
        first(),
        tap(hasError => {
            if (hasError) handleNavigationCanActivateUseCase('/error-ssr', route.params, router);
        }),
        map(hasError => !hasError),
    );
};
